import GeoLocation from "./geo-location";
GeoLocation();
import AOS from "aos";
import "aos/dist/aos.css";
import jQuery from "jquery";
import Cookies from 'js-cookie';
window.$ = window.jQuery = jQuery;

import Splide from "@splidejs/splide";
import featherLight from "featherlight";
import infiniteScroll from "infinite-scroll";
import scrollTo from "jquery.scrollto";
import submitHubspotForm from "./submit-hubspot-form";
import "@lottiefiles/lottie-player";
import { create } from '@lottiefiles/lottie-interactivity';
import particleWave from "./particle-wave";
import gsapAnimations from "./gsap-animations";
import riveAnimations from './rive-animations'
import Remodal from "./Remodal";

import Swiper, { Navigation } from 'swiper';
import "swiper/swiper.css";
Swiper.use([Navigation]);
new Remodal();
var imagesLoaded = require("imagesloaded");


window.addEventListener("load", function() {
  AOS.init({
    ease: "ease-in-out",
    duration: 600,
    mirror: false,
    once: true,
    offset: 0,
  });
});

imagesLoaded(".page-template-inner", function() {
  AOS.refresh();
});

function newsletterForm() {
  const form = document.querySelector(".newsletter-form");
  if (!form) return;
  const emailValidRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    const errorMessageDiv = form.querySelector(".form-errors");
    errorMessageDiv.innerHTML = "";

    const gdprInput = form.querySelector('input[name="policy-agree"]');
    const emailInput = form.querySelector('input[name="email"]');
    const emailValue = emailInput.value;

    if (
      gdprInput.checked &&
      emailValue.length &&
      emailValidRegex.test(emailValue)
    ) {
      const res = await submitHubspotForm({
        formId: "ad6c5851-c0fc-4465-a470-11aa4309bf7e",
        fields: {
          email: emailValue,
        },
      });

      if (res.status !== 200) {
        if (res.data?.errors?.length) {
          errorMessageDiv.innerHTML = res.data.errors
            .map((err) => err.message)
            .join(", ");
        }
      } else {
        document.querySelector(".before-sent").classList.add("is-sent");
        document.querySelector(".after-sent").innerHTML =
          res.data.inlineMessage;
      }
    }

    return false;
  });
}

function externalLinksTargetBlank() {
  [...document.getElementsByTagName("a")].forEach((b) => {
    b.getAttribute("href") &&
      b.hostname !== location.hostname &&
      (b.target = "_blank");
  });
}

function languageSwitcherOverride() {
  const els = [...document.querySelectorAll('.wpml-ls-item')];
  els.forEach(el => {
    const link = el.querySelector('a');
    link.href = link.href+'?lo';
    link && link.addEventListener('click', (e) => {
      e.preventDefault();
      const lang = link.querySelector('.wpml-ls-native').getAttribute('lang');
      if (lang) {
        console.log(lang);
        Cookies.set('lang', lang, { expires: 1 });
      }
      window.location = link.href;
    })
  })
}

function headerScroll() {
  const body = document.querySelector('body');
  window.addEventListener('scroll', function () {
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    if (scroll > 0) {
      body.classList.add('is-scrolled');
    } else {
      body.classList.remove('is-scrolled');
    }
  });
}

function eCommerceAcc() {
  const container = document.querySelector('.vertical-sliding-accordion');
  if (!container) return;

  const textEls = [...container.querySelectorAll('.acc-text')];
  const bgEl = container.querySelector('.acc-bg-color-change');
  const imgTranslateEl = container.querySelector('.acc-translate-y-on-images');

  textEls.forEach((textEl, i) => {
    const heading = textEl.querySelector('.acc-text-heading');

    const changeSlide = (el) => {
      textEls.forEach(rs => rs.classList.remove('is-open'))
      el.classList.add('is-open');

      const dataIndex = el.getAttribute('data-index');
      bgEl.style.backgroundColor = accBgColors[dataIndex];
      imgTranslateEl.style.transform = `translateY(-${dataIndex*100}%)`;

      if (dataIndex == 5) {
        const player = container.querySelector("lottie-player");

        if (player) {
          player.stop(0);
          player.play(0);
        }
      }
    }

    heading.addEventListener('click', ()=> {
      changeSlide(textEl);
      if (window.innerWidth < 1024) {
        textEl.scrollIntoView();
      }
    });
    // change to next slide when progress bar completes
    textEl.querySelector('.acc-text-progress').addEventListener('transitionend', () => changeSlide(textEls[i+1] || textEls[0]), false);
  });


  document.addEventListener(`aos:in:verical-sliding-accordion`, () => {
    container.classList.add('is-in-view');
  });
}


function mobileSwiper() {
  new Swiper('.swiper', {
    speed: 400,
    slidesPerView:1,
    spaceBetween: 50,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

}

function inPageNav() {
  const el = document.querySelector('.in-page-navigation');
  const header = document.querySelector('header.header');
  if (!el || !header) return;

  el.style.top = header.clientHeight+'px';
  window.addEventListener('resize', () => {
    el.style.top = header.clientHeight+'px';
  });

  const spyScrolling = ( ) => {
    const sections = [...document.querySelectorAll( '.anchor-link' )];

    window.addEventListener('scroll', ()=> {
      const scrollPos = (document.documentElement.scrollTop || document.body.scrollTop) + header.clientHeight + el.clientHeight;

      sections.forEach(section => {
        if (section.offsetTop <= scrollPos) {
          const activeEl = document.querySelector('.is-active');
          if (activeEl) {
            activeEl.classList.remove('is-active');
          }
          const sEl = document.querySelector( `a[href*=${section.id}]` );
          if (sEl) {
            const par = sEl.parentNode;
            if (par) {
              par.classList.add('is-active');
            }
          }
        }
      });
    })
  }
  spyScrolling();

}

document.addEventListener("DOMContentLoaded", () => {
  inPageNav();
  gsapAnimations();
  eCommerceAcc();
  headerScroll();
  riveAnimations();
  languageSwitcherOverride();
  runAnimations();
  newsletterForm();
  externalLinksTargetBlank();
  mobileSwiper();

  if (document.querySelector(".wave-overlay-desktop")) {
    particleWave();
  }

  const lottieAnimations = document.querySelectorAll(".mobile-lottie");
  [...lottieAnimations].map((el, i) => {
    const player = el.querySelector("lottie-player");
    if (player) {
      document.addEventListener(`aos:in:lottieinview${i}`, () => {
        player.play();
      });
    }
  });

  setTimeout(() => {
    AOS.refresh();
  }, 200);

  ////////////////////////////
  // ACCORDIONS
  ////////////////////////////

  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    const item = acc[i];
    const heading = item.querySelector(".accordion__header");
    heading.addEventListener("click", () => {
      item.classList.toggle("active");

      [].forEach.call(
        acc,
        function(el) {
          if (el !== item) {
            el.classList.remove("active");
          }
        },
        this
      );
    });
  }

  ////////////////////////////
  // Countdown
  ////////////////////////////

  function getTimeRemaining(endtime) {
    const total = Date.parse(endtime) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
    const days = Math.floor(total / (1000 * 60 * 60 * 24));

    return {
      total,
      days,
      hours,
      minutes,
      seconds,
    };
  }

  function initializeClock(id, endtime) {
    const clock = document.getElementById(id);
    const daysSpan = clock.querySelector(".days");
    const hoursSpan = clock.querySelector(".hours");
    const minutesSpan = clock.querySelector(".minutes");
    const secondsSpan = clock.querySelector(".seconds");

    function updateClock() {
      const t = getTimeRemaining(endtime);

      daysSpan.innerHTML = t.days;
      hoursSpan.innerHTML = ("0" + t.hours).slice(-2);
      minutesSpan.innerHTML = ("0" + t.minutes).slice(-2);
      secondsSpan.innerHTML = ("0" + t.seconds).slice(-2);

      if (t.total <= 0) {
        clearInterval(timeinterval);
      }
    }

    updateClock();
    const timeinterval = setInterval(updateClock, 1000);
  }

  var date = document.querySelector("#clockdiv");

  if (date) {
    date = date.getAttribute("data-date");

    const deadline = new Date(Date.parse(date));
    initializeClock("clockdiv", deadline);
  }

  ////////////////////////////
  // SOLUTIONS SCROLLTO
  ////////////////////////////

  if (window.location.hash) {
    var hash = window.location.hash;

    if (hash == "#acquire-new-customers") {
      $(document).scrollTo("#acquire-new-customers", 1500, {
        offset: -100,
      });
    } else if (hash == "#grow-your-customer-ltv") {
      $(document).scrollTo(jQuery("#grow-your-customer-ltv"), 1500, {
        offset: -100,
      });
    } else if (hash == "#win-back-and-retain-customers") {
      $(document).scrollTo(jQuery("#win-back-and-retain-customers"), 1500, {
        offset: -300,
      });
    }

    AOS.refresh();
  }

  ////////////////////////////
  // PLATFORM SCROLLTO
  ////////////////////////////

  $(".title--platform a.hasScrollTo").click(function(e) {
    e.preventDefault();
    $(document).scrollTo($(this).attr("href"), 1500, { offset: -300 });
    AOS.refresh();
  });


  const lottieElements = document.getElementsByTagName('lottie-player');
  for (var i = 0; i < lottieElements.length; i++) {
    lottieElements[i].addEventListener('play', (event) => {
      if (event.target.shadowRoot && event.target.shadowRoot.querySelector('svg')) {
        event.target.shadowRoot.querySelector('svg').style.transform = '';
      }
    });
    // lottieElements[i].play(); // trigger (again)
  }
});

//Run the animation on all elements with a class of 'countup'
const runAnimations = () => {
  // The animation function, which takes an Element
  const animateCountUp = (el) => {
    function round(value, precision) {
      var multiplier = Math.pow(10, precision || 0);
      return Math.round(value * multiplier) / multiplier;
    }

    // How long you want the animation to take, in ms
    const animationDuration = 2000;
    // Calculate how long each ‘frame’ should last if we want to update the animation 60 times per second
    const frameDuration = 1000 / 60;
    // Use that to calculate how many frames we need to complete the animation
    const totalFrames = Math.round(animationDuration / frameDuration);
    // An ease-out function that slows the count as it progresses
    const easeOutQuad = (t) => t * (2 - t);
    let frame = 0;
    const countTo = el.innerHTML.replace(',', '.');
    const decimals = el.getAttribute("data-final").indexOf(".") > -1 ? 1 : 0;
    const lang = document.querySelector('html').lang || '';
    // Start the animation running 60 times per second
    const counter = setInterval(() => {
      frame++;
      // Calculate our progress as a value between 0 and 1
      // Pass that value to our easing function to get our
      // progress on a curve
      const progress = easeOutQuad(frame / totalFrames);
      // Use the progress value to calculate the current count
      const currentCount = round(countTo * progress, decimals);

      // If the current count has changed, update the element
      if (el.innerHTML !== currentCount) {
        el.innerHTML = lang.toLowerCase() === 'pt-br' ? currentCount.toString().replace('.',',') : currentCount;
      }

      // If we've reached our last frame, stop the animation
      if (frame === totalFrames) {
        clearInterval(counter);
      }
    }, frameDuration);
  };

  const countupEls = document.querySelectorAll(".countup");
  [...countupEls].map((el, i) => {
    document.addEventListener(`aos:in:counting${i}`, () => {
      animateCountUp(el);
    });
  });
};

// Scroll hubspot form into view after submit
window.addEventListener("message", (event) => {
  if (
    event.data.type === "hsFormCallback" &&
    event.data.eventName === "onFormSubmitted" &&
    event.data.id
  ) {
    const form = document.querySelector(".hbspt-form");
    if (form) {
      form.scrollIntoView({ block: "center" });
    }
  }
});

//////////////////
// TIMELINE SLIDER
//////////////////

$(window).on("load resize", function(e) {
  if (windowWidth <= 640) {
    $(".splide.type-timeline-content").each(function() {
      var splideTimelineNavMobile = new Splide(".splide.type-timeline-nav", {
        isNavigation: true,
        pagination: false,
        direction: "ltr",
        autoHeight: true,
        autoplay: false,
        arrows: false,
        rewind: false,
        type: "loop",
        clones: 6,
        gap: 20,
      }).mount();

      var splideTimelineContentMobile = new Splide(
        ".splide.type-timeline-content",
        {
          pagination: false,
          direction: "ltr",
          height: "295px",
          autoplay: false,
          arrows: false,
          rewind: false,
          type: "loop",
          clones: 6,
        }
      );

      splideTimelineContentMobile.sync(splideTimelineNavMobile).mount();
    });
  } else if (windowWidth > 640) {
    $(".splide.type-timeline-content").each(function() {
      var splideTimelineNav = new Splide(".splide.type-timeline-nav", {
        isNavigation: true,
        pagination: false,
        direction: "ttb",
        autoHeight: true,
        autoplay: true,
        height: "520px",
        arrows: false,
        type: "loop",
        clones: 6,
        breakpoints: {
          640: {
            destroy: true,
          },
        },
        gap: 40,
      }).mount();

      var splideTimelineContent = new Splide(".splide.type-timeline-content", {
        pagination: false,
        direction: "ttb",
        height: "520px",
        autoplay: true,
        arrows: false,
        breakpoints: {
          640: {
            destroy: true,
          },
        },
      });

      splideTimelineContent.sync(splideTimelineNav).mount();
    });
  }

  if (windowWidth < 1024) {
    $(".splide.type-vertical").each(function() {
      var splide = new Splide(".splide.type-vertical", {
        height: "600px",
        direction: "ltr",
        easing: "ease",
        autoplay: true,
        arrows: false,
        type: "fade",
        speed: 850,
        breakpoints: {
          640: {
            height: "490px",
          },
        },
      }).mount();
    });
  } else if (windowWidth >= 1024) {
    $(".splide.type-vertical").each(function() {
      var splide = new Splide(".splide.type-vertical", {
        height: "500px",
        direction: "ttb",
        easing: "ease",
        autoplay: true,
        arrows: false,
        type: "fade",
        speed: 850,
        breakpoints: {
          900: {
            height: "480px",
          },
          640: {
            height: "490px",
          },
        },
      }).mount();
    });
  }

  AOS.refresh();
});

var windowWidth = $(window).width();

window.addEventListener("resize", function(event) {
  windowWidth = $(window).width();
});

$(document).ready(function() {
  if (windowWidth > 1024) {
    $(".header__nav__item.has-sub-menu").hover(
      function() {
        $(this).find(".sub-menu").stop().fadeIn();
      },
      function() {
        $(this).find(".sub-menu").stop().fadeOut();
      }
    );
  }

  $(".main-nav-toggle .tg-hamburger").data("status", "false");
  $(".main-nav-toggle .tg-hamburger").on("click", function() {
    if ($(this).data("status") === "false") {
      $("body").addClass("nav-open");
      $(".main-nav-toggle .tg-hamburger-outer").addClass("open");
      $(".header__nav__container").fadeIn();
      $(this).data("status", "true");
    } else if ($(this).data("status") === "true") {
      $("body").removeClass("nav-open");
      $(".main-nav-toggle .tg-hamburger-outer").removeClass("open");
      $(".header__nav__container").fadeOut();
      $(this).data("status", "false");
    }
  });

  $(".header__nav__container li.has-sub-menu > a").on("click", function(e) {
    if (windowWidth <= 1024) {
      e.preventDefault();
    }
    $(this)
      .parent()
      .toggleClass("sub-menu-active");
  });

  ////////////////
  // SPLIDE SLIDER
  ////////////////

  $(".splide.type-horizontal").each(function() {
    var splide = new Splide(".splide.type-horizontal", {
      arrows: false,
      perPage: 1,
      breakpoints: {
        900: {
          perPage: 2,
        },
      },
    }).mount();
  });

  $(".splide.type-horz-dots").each(function() {
    var splide = new Splide(".splide.type-horz-dots", {
      arrows: false,
      type: "fade",
      perPage: 1,
    }).mount();
  });

  var elms = document.getElementsByClassName(
    "splide-type-horz-dots-with-arrows"
  );
  for (var i = 0, len = elms.length; i < len; i++) {
    new Splide(elms[i], {
      type: "slide",
      rewind: true,
      autoplay: true,
      perPage: 1,

    }).mount();
  }

  $(".splide.type-quote-callout").each(function() {
    var $prevBtn = $(this).find(".splide__arrow--prev");
    var $nextBtn = $(this).find(".splide__arrow--next");
    var $thisSplide = $(this);

    var splide = new Splide(".splide.type-quote-callout", {
      pagination: false,
      rewind: false,
      type: "fade",
      perPage: 1,
    }).mount();

    splide.on("moved", function(newIndex, oldIndex, destIndex) {
      if (destIndex >= 1) {
        $prevBtn.addClass("active");
      } else {
        $prevBtn.removeClass("active");
      }

      if (destIndex == splide.length - 1) {
        $nextBtn.addClass("inactive");
      } else {
        $nextBtn.removeClass("inactive");
      }
    });
  });

  $(".type-horizontal-full-width-blocks").each(function() {
    var $progressBar = $(".progress");
    var $prevBtn = $(this).find(".splide__arrow--prev");
    var $nextBtn = $(this).find(".splide__arrow--next");
    var $splideType = $(this).attr("data-sliderType");
    var $thisSplide = $(this);

    if (windowWidth < 1024) {
      if ($splideType == "smallerSlides") {
        $progressBar
          .css("background-size", "8.666% 100%")
          .attr("aria-valuemin", "8.666")
          .attr("aria-valuenow", "8.666");
      }
    }

    var splide = new Splide(this, {
      pagination: false,
      rewindSpeed: 200,
      trimSpace: false,
      autoWidth: true,
      type: "slide",
      rewind: true,
      gap: "25px",
      focus: "0",
    }).mount();

    //splide.go(0);

    splide.on("moved", function(newIndex, oldIndex, destIndex) {
      var prog = 100;

      if (windowWidth >= 375 && windowWidth < 900) {
        if ($splideType == "homeSolutions") {
          prog = 150;
        } else {
          prog = 100;
        }
      }

      if (windowWidth >= 900 && windowWidth < 1280) {
        if ($splideType == "homeSolutions") {
          prog = 200;
        } else if ($splideType == "innerDefault") {
          prog = 150;
        } else {
          prog = 125;
        }
      }

      if (windowWidth >= 1280 && windowWidth < 1438) {
        if ($splideType == "homeSolutions") {
          prog = 200;
        } else {
          prog = 150;
        }
      }

      if (windowWidth >= 1439) {
        if ($splideType == "smallerSlides" || $splideType == "largeTitle") {
          prog = 150;
        } else {
          prog = 200;
        }
      }

      var calc = (newIndex / (splide.length - 1)) * prog;

      if (destIndex < splide.length - 1) {
        splide.options = { drag: true };
      }

      if (destIndex > 0) {
        $prevBtn.css("display", "flex");
      } else {
        $prevBtn.css("display", "none");
      }

      if (windowWidth <= 515) {
        if ($splideType == "smallerSlides") {
          if (destIndex > splide.length - 1) {
            splide.go(splide.length - 1);
          }
          if (destIndex < splide.length - 1) {
            $nextBtn.css("display", "flex");
          } else {
            $nextBtn.css("display", "none");
          }
        } else {
          if (destIndex > splide.length - 1) {
            splide.go(splide.length - 1);
          }
          if (destIndex < splide.length - 1) {
            $nextBtn.css("display", "flex");
          } else {
            $nextBtn.css("display", "none");
          }
        }
      }

      if (windowWidth > 515 && windowWidth < 900) {
        if ($splideType == "smallerSlides") {
          if (destIndex > splide.length - 1) {
            splide.go(splide.length - 1);
          }
          if (destIndex < splide.length - 1) {
            $nextBtn.css("display", "flex");
          } else {
            $nextBtn.css("display", "none");
          }
        } else {
          if (destIndex > splide.length - 1) {
            splide.go(splide.length - 1);
          }
          if (destIndex < splide.length - 1) {
            $nextBtn.css("display", "flex");
          } else {
            $nextBtn.css("display", "none");
          }
        }
      }

      if (windowWidth >= 900 && windowWidth <= 1024) {
        if ($splideType == "homeSolutions") {
          if (destIndex > splide.length - 2) {
            splide.go(splide.length - 2);
          }
          if (destIndex < splide.length - 2) {
            $nextBtn.css("display", "flex");
          } else {
            $nextBtn.css("display", "none");
          }
        } else if ($splideType == "smallerSlides") {
          if (destIndex > splide.length - 2) {
            splide.go(splide.length - 2);
          }
          if (destIndex < splide.length - 2) {
            $nextBtn.css("display", "flex");
          } else {
            $nextBtn.css("display", "none");
          }
        } else if ($splideType == "innerDefault") {
          if (destIndex > splide.length - 2) {
            splide.go(splide.length - 2);
          }
          if (destIndex < splide.length - 2) {
            $nextBtn.css("display", "flex");
          } else {
            $nextBtn.css("display", "none");
          }
        } else {
          if (destIndex > splide.length - 1) {
            splide.go(splide.length - 1);
          }
          if (destIndex < splide.length - 1) {
            $nextBtn.css("display", "flex");
          } else {
            $nextBtn.css("display", "none");
          }
        }
      }

      if (windowWidth >= 1025 && windowWidth < 1280) {
        if ($splideType == "homeSolutions") {
          if (destIndex > splide.length - 2) {
            splide.go(splide.length - 2);
          }
          if (destIndex < splide.length - 2) {
            $nextBtn.css("display", "flex");
          } else {
            $nextBtn.css("display", "none");
          }
        } else if ($splideType == "smallerSlides") {
          if (destIndex > splide.length - 2) {
            splide.go(splide.length - 2);
          }
          if (destIndex < splide.length - 2) {
            $nextBtn.css("display", "flex");
          } else {
            $nextBtn.css("display", "none");
          }
        } else if ($splideType == "innerDefault") {
          if (destIndex > splide.length - 2) {
            splide.go(splide.length - 2);
          }
          if (destIndex < splide.length - 2) {
            $nextBtn.css("display", "flex");
          } else {
            $nextBtn.css("display", "none");
          }
        } else {
          if (destIndex > splide.length - 1.5) {
            splide.go(splide.length - 1.5);
          }
          if (destIndex < splide.length - 1.5) {
            $nextBtn.css("display", "flex");
          } else {
            $nextBtn.css("display", "none");
          }
        }
      }

      if (windowWidth >= 1280 && windowWidth < 1438) {
        if ($splideType == "homeSolutions") {
          if (destIndex > splide.length - 2) {
            splide.go(splide.length - 2);
          }
          if (destIndex < splide.length - 2) {
            $nextBtn.css("display", "flex");
          } else {
            $nextBtn.css("display", "none");
          }
        } else if ($splideType == "smallerSlides") {
          if (destIndex > splide.length - 3) {
            splide.go(splide.length - 3);
          }
          if (destIndex < splide.length - 3) {
            $nextBtn.css("display", "flex");
          } else {
            $nextBtn.css("display", "none");
          }
        } else if ($splideType == "innerDefault") {
          if (destIndex > splide.length - 2) {
            splide.go(splide.length - 2);
          }
          if (destIndex < splide.length - 2) {
            $nextBtn.css("display", "flex");
          } else {
            $nextBtn.css("display", "none");
          }
        } else {
          if (destIndex > splide.length - 1.5) {
            splide.go(splide.length - 1.5);
          }
          if (destIndex < splide.length - 1.5) {
            $nextBtn.css("display", "flex");
          } else {
            $nextBtn.css("display", "none");
          }
        }
      }

      if (windowWidth > 1439) {
        if ($splideType == "smallerSlides") {
          if (destIndex > splide.length - 3) {
            splide.go(splide.length - 3);
          }
          if (destIndex < splide.length - 3) {
            $nextBtn.css("display", "flex");
          } else {
            $nextBtn.css("display", "none");
          }
        } else {
          if (destIndex > splide.length - 2) {
            splide.go(splide.length - 2);
          }
          if (destIndex < splide.length - 2) {
            $nextBtn.css("display", "flex");
          } else {
            $nextBtn.css("display", "none");
          }
        }
      }

      if (newIndex == 0) {
        if (windowWidth >= 375 && windowWidth < 900) {
          if ($splideType == "smallerSlides") {
            $progressBar
              .css("background-size", "8.666% 100%")
              .attr("aria-valuenow", calc);
          } else {
            $progressBar
              .css("background-size", "16.666% 100%")
              .attr("aria-valuenow", calc);
          }
        } else {
          $progressBar
            .css("background-size", "16.666% 100%")
            .attr("aria-valuenow", calc);
        }
      } else {
        $progressBar
          .css("background-size", calc + "% 100%")
          .attr("aria-valuenow", calc);
      }
    });

    /**
    splide.on("moved", function(newIndex, oldIndex, destIndex) {

      if (windowWidth <= 1024) {
        if ($splideType == "smallerSlides") {
          if (destIndex < splide.length - 2) {
            $nextBtn.css("display", "flex");
          } else {
            $nextBtn.css("display", "none");
          }
        } else {
          if (destIndex < splide.length - 1) {
            $nextBtn.css("display", "flex");
          } else {
            $nextBtn.css("display", "none");
          }
        }
      }

      if (windowWidth > 1025 && windowWidth < 1438) {
        if ($splideType == "smallerSlides") {
          if (destIndex < splide.length - 3.5) {
            $nextBtn.css("display", "flex");
          } else {
            $nextBtn.css("display", "none");
          }
        } else {
          if (destIndex < splide.length - 1.5) {
            $nextBtn.css("display", "flex");
          } else {
            $nextBtn.css("display", "none");
          }
        }
      }
      if (windowWidth > 1439) {
        if ($splideType == "smallerSlides") {
          if (destIndex < splide.length - 3) {
            $nextBtn.css("display", "flex");
          } else {
            $nextBtn.css("display", "none");
          }
        } else {
          if (destIndex > splide.length - 2) {
          } else {
            splide.options = { drag: false };
          }
        }
      }

    });
    **/
  });

  $(".type-horizontal-case-study-blocks").each(function() {
    var $progressBar = $(".progress");
    var $prevBtn = $(this).find(".splide__arrow--prev");

    var splide = new Splide(".type-horizontal-case-study-blocks", {
      pagination: false,
      trimSpace: false,
      rewind: true,
      autoWidth: true,
      type: "slide",
      gap: "25px",
    }).mount();

    splide.on("move", function(newIndex, oldIndex, destIndex) {
      var calc = (newIndex / (splide.length - 1)) * 100;

      if (destIndex > 0) {
        $prevBtn.css("display", "flex");
      } else {
        $prevBtn.css("display", "none");
      }

      if (newIndex == 0) {
        $progressBar
          .css("background-size", "16.666% 100%")
          .attr("aria-valuenow", calc);
      } else {
        $progressBar
          .css("background-size", calc + "% 100%")
          .attr("aria-valuenow", calc);
      }
    });
  });

  $(".type-horizontal-images-with-overlay").each(function() {
    var $prevBtn = $(this).find(".splide__arrow--prev");
    var $nextBtn = $(this).find(".splide__arrow--next");

    var splide = new Splide(".type-horizontal-images-with-overlay", {
      pagination: false,
      trimSpace: false,
      rewindSpeed: 200,
      autoWidth: true,
      trimSpace: true,
      type: "slide",
      rewind: true,
      gap: "25px",
      focus: "0",
    }).mount();

    splide.on("move", function(newIndex, oldIndex, destIndex) {
      if (destIndex > 0) {
        $prevBtn.css("display", "flex");
      } else {
        $prevBtn.css("display", "none");
      }

      if (windowWidth <= 515) {
        if (destIndex < splide.length - 1) {
          $nextBtn.css("display", "flex");
        } else {
          $nextBtn.css("display", "none");
        }
      }

      if (windowWidth > 516 && windowWidth <= 1024) {
        if (destIndex < splide.length - 2) {
          $nextBtn.css("display", "flex");
        } else {
          $nextBtn.css("display", "none");
        }
      }

      if (windowWidth > 1025 && windowWidth < 1438) {
        if (destIndex < splide.length - 3.5) {
          $nextBtn.css("display", "flex");
        } else {
          $nextBtn.css("display", "none");
        }
      }

      if (windowWidth > 1439) {
        if (destIndex < splide.length - 3) {
          $nextBtn.css("display", "flex");
        } else {
          $nextBtn.css("display", "none");
        }
      }
    });

    $(this)
      .find(".splide__slide")
      .hover(function() {
        $(this)
          .find(".title-area")
          .toggleClass("slideUpTop");
        $(this)
          .find(".title-area .block-content .prose")
          .delay(150)
          .animate({ opacity: 100 }, 4000);
      });
  });

  /////////////////////
  // VERTICAL ACCORDION
  /////////////////////

  $(".accordion-vertical").each(function() {
    var currentSection = $(this);

    currentSection.find(".title-toggle").click(function() {
      $(this)
        .find(".accord-section-toggle")
        .toggleClass("active");
      $(this)
        .parent()
        .find(".position-list")
        .fadeToggle();
    });
  });

  /////////////////////
  // 4x4 GRID
  /////////////////////

  $(".fourbyfour-grid").each(function() {
    var currentSection = $(this);

    currentSection.find(".show-content-toggle").click(function(e) {
      e.preventDefault();

      var btnText = $(this).attr("data-btnText");
      var ItemNum = $(this).attr("data-ItemNum");

      currentSection.find(".block-content").hide();
      $(".show-content-toggle").html(btnText);

      if ($(this).data("clicked") == 1) {
        currentSection.find(".grid-outer").removeClass("active");
        $(this).html(btnText);
        $(this)
          .parent()
          .parent()
          .find(".block-content")
          .fadeOut();
        $(this)
          .parent()
          .parent()
          .addClass("active");
        $(this).data("clicked", 0);
      } else {
        currentSection.find(".grid-outer").addClass("active");
        const htmlLang = document.querySelector('html').getAttribute('lang') || 'en';
        const text = (htmlLang && htmlLang.split('-')[0] === 'pt') ? 'fechar' :'close';

        $(this).html(text);
        $(this)
          .parent()
          .parent()
          .find(".block-content")
          .fadeIn();
        $(this)
          .parent()
          .parent()
          .removeClass("active");
        $(this).data("clicked", 1);
        $(
          ".fourbyfour-grid .grid-item:not(.item-" +
            ItemNum +
            ") .show-content-toggle"
        ).data("clicked", 0);
      }
    });
  });

  ////////////
  // ACCORDION
  ////////////

  $(".section-has-accordion").each(function() {
    var accoridion_toggle = $(this).find(".accordion-toggle");
    var accoridion_image = $(this).find(".accordion-image");

    $(".accordion-toggle").click(function() {
      var tab_id = $(this).attr("data-toggle-num");
      var target_image = $(
        '.accordion-image[data-toggle-num="' + tab_id + '"]'
      );

      accoridion_toggle.removeClass("active");
      $(this).addClass("active");

      accoridion_image.removeClass("active");
      $(target_image).addClass("active");
    });
  });

  $(".load-faq").on("click", function(e) {
    e.preventDefault();
    $(this)
      .find(".load-more")
      .toggleClass("hidden");
    $(this)
      .find(".show-less")
      .toggleClass("hidden");
    $(".faq-container").toggleClass("active");
  });

  $(".grad-modal-init").on("click", function(e) {
    e.preventDefault();
    $("body").addClass("grad-open");
  });

  $(".grad-modal-close").on("click", function(e) {
    e.preventDefault();
    $("body").removeClass("grad-open");
  });

  ///////////////////////////////
  // ACCORDION - EBOOK
  ///////////////////////////////

  $(".ebook-accordion").each(function() {
    var accoridion_toggle = $(this).find(".accordion-toggle");
    var tab_id = $(this).attr("data-toggle-num");

    $(".accordion-toggle").click(function() {
      accoridion_toggle.removeClass("active");
      $(this).addClass("active");
    });
  });

  ///////////////////////////////////////
  // CONTACT US - FORM DESTINATION TOGGLE
  ///////////////////////////////////////

  $(".form-dest-toggle").click(function() {
    $(this)
      .parent()
      .find(".form-dest-list")
      .toggle();
  });

  $(".form-dest-list li span").click(function() {
    var selectedVal = $(this).attr("data-selected-val");

    $(".form-dest-toggle").html(selectedVal);
    $("#input_2_9").val(selectedVal);

    $(".form-dest-toggle-outer .form-dest-list").toggle();
  });

  ////////////////////////////
  // HOTSPOT AREA INTERACTIONS
  ////////////////////////////

  $(".hotspot").each(function() {
    var $this = $(this),
      top = $this.data("top"),
      left = $this.data("left");

    $this
      .css({
        top: top + "%",
        left: left + "%",
      })
      .addClass("is-visible");
  });

  $(".hotspot").on("click", function(e) {
    e.preventDefault();
    $(".hotspot-overlay").hide();
    $(".hotspot-area").addClass("active");

    var id = $(this).data("hotspot-id");
    $("#overlay-" + id).fadeIn(1100);
  });

  $(".close-overlay").on("click", function(e) {
    e.preventDefault();
    $(".hotspot-area").removeClass("active");
    $(".hotspot-overlay").fadeOut(1100);
  });

  $(document).mouseup(function(e) {
    var container = $(".hotspot-overlay");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $(".hotspot-area").removeClass("active");
      $(".hotspot-overlay").hide();
    }
  });
});
